document.addEventListener('DOMContentLoaded', function () {
  var formConfigs = document.querySelectorAll('[data-service-area-form]');
  if (!formConfigs.length) return;

  formConfigs.forEach(function (config) {
    var wrapper = config.closest('[data-service-area-form-wrapper]');
    if (!wrapper) return;

    var form = wrapper.querySelector('form');
    if (!form) return;

    var zipInput = form.querySelector('[data-zip-input]');
    var serviceMessage = form.querySelector('[data-service-message]');
    var serviceStatusInput = form.querySelector('[data-service-status-input]');
    var serviceNoteInput = form.querySelector('[data-service-note-input]');
    var submitButton = form.querySelector('button[type="submit"]');

    var allowedZips = (config.dataset.allowedZips || '')
      .split(',')
      .map(function (zip) { return zip.trim(); })
      .filter(Boolean);

    var outOfAreaMode = config.dataset.outOfAreaMode || 'block';
    var outOfAreaMessage =
      config.dataset.outOfAreaMessage ||
      'We do not currently serve your ZIP code.';

    function setFieldError(fieldName, message) {
      var errorEl = form.querySelector('[data-error-for="' + fieldName + '"]');
      if (errorEl) errorEl.textContent = message || '';
    }

    function clearFieldErrors() {
      form.querySelectorAll('.service-area-form__field-error').forEach(function (el) {
        el.textContent = '';
      });
    }

    function focusFirstError() {
      var firstError = form.querySelector('.service-area-form__field-error:not(:empty)');
      if (firstError) {
        firstError.setAttribute('tabindex', '-1');
        firstError.focus();
      }
    }

    function sanitizeZip(value) {
      return (value || '').replace(/\D/g, '').slice(0, 5);
    }

    function getZipStatus(zip) {
      if (!zip || !/^\d{5}$/.test(zip)) {
        return { validFormat: false, inArea: false };
      }
      return {
        validFormat: true,
        inArea: allowedZips.includes(zip)
      };
    }

    function setSubmitEnabled(enabled) {
      if (!submitButton) return;
      submitButton.disabled = !enabled;
      submitButton.classList.toggle('is-blocked', !enabled);
    }

    function updateZipState() {
      if (!zipInput) return;

      var zip = sanitizeZip(zipInput.value);
      var status = getZipStatus(zip);

      serviceMessage.hidden = true;
      serviceMessage.classList.remove(
        'service-area-form__service-message--ok',
        'service-area-form__service-message--warn'
      );

      if (serviceStatusInput) serviceStatusInput.value = '';
      if (serviceNoteInput) serviceNoteInput.value = '';

      if (!zip) {
        if (outOfAreaMode === 'block') setSubmitEnabled(true);
        return;
      }

      if (!status.validFormat) {
        if (outOfAreaMode === 'block') setSubmitEnabled(false);
        return;
      }

      if (status.inArea) {
        serviceMessage.hidden = false;
        serviceMessage.classList.add('service-area-form__service-message--ok');
        serviceMessage.textContent = 'Good news, your ZIP code is within our service area.';
        if (serviceStatusInput) serviceStatusInput.value = 'In service area';
        if (serviceNoteInput) serviceNoteInput.value = 'ZIP validated on frontend and appears to be in service area.';
        if (outOfAreaMode === 'block') setSubmitEnabled(true);
        return;
      }

      // Valid ZIP, out of area
      serviceMessage.hidden = false;
      serviceMessage.classList.add('service-area-form__service-message--warn');
      serviceMessage.textContent = outOfAreaMessage;
      if (serviceStatusInput) serviceStatusInput.value = 'Out of service area';
      if (serviceNoteInput) serviceNoteInput.value = 'ZIP validated on frontend and appears to be outside the listed service area.';

      if (outOfAreaMode === 'block') {
        setSubmitEnabled(false);
      }
    }

    if (zipInput) {
      zipInput.addEventListener('input', function () {
        zipInput.value = sanitizeZip(zipInput.value);
        updateZipState();
      });
      zipInput.addEventListener('blur', function () {
        zipInput.value = sanitizeZip(zipInput.value);
        updateZipState();
      });
    }

    form.addEventListener('submit', function (event) {
      clearFieldErrors();

      var nameInput = form.querySelector('[name="contact[name]"]');
      var emailInput = form.querySelector('[name="contact[email]"]');
      var name = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var zip = zipInput ? sanitizeZip(zipInput.value) : '';

      if (zipInput) zipInput.value = zip;

      var hasErrors = false;

      if (!name) {
        setFieldError('name', 'Name is required.');
        hasErrors = true;
      }

      if (!email) {
        setFieldError('email', 'Email is required.');
        hasErrors = true;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setFieldError('email', 'Please enter a valid email address.');
        hasErrors = true;
      }

      if (!zip) {
        setFieldError('zip', 'ZIP code is required.');
        hasErrors = true;
      } else if (!/^\d{5}$/.test(zip)) {
        setFieldError('zip', 'ZIP code must be exactly 5 digits.');
        hasErrors = true;
      }

      if (hasErrors) {
        event.preventDefault();
        focusFirstError();
        return;
      }

      // Safety net in case button state is somehow bypassed
      var zipStatus = getZipStatus(zip);
      if (zipStatus.validFormat && !zipStatus.inArea && outOfAreaMode === 'block') {
        event.preventDefault();
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-submitting');
        submitButton.textContent = 'Submitting...';
      }
    });

    updateZipState();
  });
});